<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>振替登録</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div formGroupName="recptJokyInfLstDto">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
                    style="margin-left:40px">
                    <mat-form-field appearance="outline"
                        class="input-form-custom tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        style="width:50%">
                        <mat-label>振替登録先</mat-label>
                        <mat-select formControlName="furikaeDiv" (selectionChange)="changeList($event.value)"
                            class="disabled-select-color">
                            <mat-option *ngFor="let type of furikaeList" [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- 他支払契約の場合 -->
                <div *ngIf="visibleTarget  ==='1'">
                    <div class="tw-flex tw-flex-row tw-flex-wrap">
                        <div
                            class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                            <mat-form-field appearance="outline" class="input-form">
                                <mat-label>支払契約番号</mat-label>
                                <input matInput formControlName="recptFixNo" autocomplete="off" minLength="10"
                                    maxlength="10" />
                                <mat-hint></mat-hint>
                            </mat-form-field>
                        </div>

                        <div
                            class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                            <mat-card-actions appearance="outline" class="btn_area_right"
                                class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[80%]">
                                <button (click)="onClickSearchFurikaesaki()" type="submit" mat-raised-button
                                    color="primary" class="btn" style="width: 100%; margin-left:40px; margin-top:5px"
                                    [disabled]="recptFixNo.invalid">振替先検索</button>
                            </mat-card-actions>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <!-- CIS外の場合 -->
                <div *ngIf="visibleTarget ==='2'">
                    <div
                        class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                        <mat-card-actions class="btn_area_right">
                            <button type="button" mat-raised-button color="primary" class="btn"
                                (click)="onClickRegistNonCis()"> 登録</button>
                        </mat-card-actions>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>